import { AsyncPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormFieldNewComponent, SdvorSelectModule } from '@sdvor/shared/ui';
import { IconModule } from '@spartacus/storefront';
import { AddressSuggestionsSelectComponent } from './address-suggestions-select.component';

@NgModule({
  declarations: [AddressSuggestionsSelectComponent],
  imports: [AsyncPipe, IconModule, ReactiveFormsModule, FormFieldNewComponent, SdvorSelectModule],
  exports: [AddressSuggestionsSelectComponent],
})
export class AddressSuggestionsSelectModule {}
